/**
 * <certs-faq-accordion>
 * Bağımlılık yok. Sertifikalarımız sayfasındaki SSS bölümü için erişilebilir
 * accordion. Tek seferde bir soru açık kalır; aynı soruya tekrar tıklanırsa kapanır.
 */
class CertsFaqAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';

    this.triggers = Array.from(this.querySelectorAll('.certs-faq-trigger'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggle(trigger));
    });
  }

  toggle(trigger) {
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    // Close any other open item for a cleaner single-open accordion experience
    this.triggers.forEach((otherTrigger) => {
      if (otherTrigger === trigger) return;
      const otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
      otherTrigger.setAttribute('aria-expanded', 'false');
      if (otherPanel) otherPanel.hidden = true;
    });

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  }
}

if (!customElements.get('certs-faq-accordion')) {
  customElements.define('certs-faq-accordion', CertsFaqAccordion);
}
